import { locator } from "@core/di";
import { Logger } from "@policoders/di";

export const logger = () => locator.resolve<Logger>("Logger");
